import PlayIcon from "@/assets/FFFFFF_play_icon.svg?react";
import clsxm from "@/lib/clsxm";
import {shouldMuteVideosAtom} from "@/store/jotaiAtoms";
import type {TInstagramMedia} from "@/store/types";
import {useAtom} from "jotai";
import {type Dispatch, type FC, type SetStateAction, memo} from "react";

const CarouselAlbumItem: FC<{
  content: TInstagramMedia;
  setHoveredAlbumItem: Dispatch<SetStateAction<TInstagramMedia | null>>;
  isHoverable?: boolean;
}> = ({content, setHoveredAlbumItem, isHoverable}) => {
  const [shouldMuteVideos, setShouldMuteVideos] = useAtom(shouldMuteVideosAtom);

  return (
    <div
      className={clsxm("overflow-hidden rounded-lg", isHoverable && "flex size-20 items-center justify-center")}
      onMouseEnter={() => {
        if (isHoverable) {
          setHoveredAlbumItem(content);
        }
      }}>
      {content.media_type === "IMAGE" || !content.media_file ? (
        <div className="min-w-ful flex min-h-full">
          <img src={content.media_file ?? content.thumbnail_file!} className="max-h-[60vh] object-cover" />
        </div>
      ) : (
        <div className="relative">
          {isHoverable ? (
            <>
              <div className="border-neutral-white-dark bg-neutral-white-dark/20 absolute top-1/2 left-1/2 flex h-12 w-12 -translate-x-1/2 -translate-y-1/2 transform items-center justify-center rounded-full border">
                <PlayIcon className="h-6 w-6 pl-1" />
              </div>
              <img src={content.thumbnail_file!} className="max-h-[60vh] object-cover" />
            </>
          ) : (
            <video
              controls
              controlsList="nodownload"
              onEnded={() => {
                setHoveredAlbumItem(null);
              }}
              src={content.media_file!}
              muted={shouldMuteVideos}
              onVolumeChange={e => setShouldMuteVideos(e.currentTarget.muted || e.currentTarget.volume === 0)}
              className="max-h-[60vh] object-contain"
            />
          )}
        </div>
      )}
    </div>
  );
};

export default memo(CarouselAlbumItem);
